import { combineReducers, compose, createStore, applyMiddleware } from "redux";
import createSagaMiddleware from "@redux-saga/core";
import { logger, crashReporter } from "../../../store";
import rootSaga from "../sagas";
import { vpps, vppsLoading, currentVppsUsers } from "../reducers/vpps.reducer";
import { vppsUsers, vppsUsersLoading } from "../reducers/vppsUsers.reducer";
import { creationMode } from "../reducers/creationMode.reducer";
import {
    creatingVpp,
    creatingVppLoading
} from "../reducers/creatingVpp.reducer";
import { subsidiaryList } from "../reducers/subsidiaries.reducer";

const vppsReducer = combineReducers({
    vpps,
    vppsLoading,
    vppsUsers,
    vppsUsersLoading,
    currentVppsUsers,
    creationMode,
    creatingVpp,
    creatingVppLoading,
    subsidiaryList
});

const composeEnhancers = window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"]
    ? window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"]({
          name: "Vpp Store"
      })
    : compose;

const sagaMiddleware = createSagaMiddleware();

export const vppsStore = createStore(
    vppsReducer,
    {},
    composeEnhancers(applyMiddleware(sagaMiddleware, logger, crashReporter))
);

export const vppsStoreSelectors = {
    vpps: (state = vppsStore.getState()) => state.vpps,
    vppsLoading: (state = vppsStore.getState()) => state.vppsLoading,
    vppsUsers: (state = vppsStore.getState()) => state.vppsUsers,
    vppsUsersLoading: (state = vppsStore.getState()) => state.vppsUsersLoading,
    currentVppsUsers: (state = vppsStore.getState()) => state.currentVppsUsers,
    creationMode: (state = vppsStore.getState()) => state.creationMode,
    creatingVpp: (state = vppsStore.getState()) => state.creatingVpp,
    creatingVppLoading: (state = vppsStore.getState()) =>
        state.creatingVppLoading,
    subsidiaryList: (state = vppsStore.getState()) => state.subsidiaryList
};

sagaMiddleware.run(rootSaga);
